import SafetyMessage from 'components/SafetyMessage';
import { Account } from 'model/IChat';
import { ExperienceSource } from 'model/IExperience';
import ErrorLabel from 'modules/host-personalized-offer/components/ErrorLabel';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import FormExperienceHeader from 'reusable-components/forms/ContactHostForm/FormExperienceHeader';
import { useTrekker } from 'utils/analytics';
import { isCordova } from 'utils/platform';
import { CONTACT_HOST_SOURCES } from '~/constants';
import FormHeader from '~/reusable-components/forms/ContactHostForm/FormHeader';
import Section from '~/reusable-components/layout/Section';

import RequestPersonalizedOfferForm from './RequestPersonalizedOfferForm';

const CSS = require('./ContactHostForm.module.scss');

interface ContactHostFormProps {
  source: CONTACT_HOST_SOURCES;
  host: Account;
  experience?: ExperienceSource;
  enabledForm?: 'personalized-offer';
}

function ContactHostForm({
  source,
  host,
  experience,
  enabledForm = 'personalized-offer',
}: ContactHostFormProps) {
  const trekker = useTrekker();
  const location = useLocation();
  const history = useHistory();
  const urlParams = new URLSearchParams(location.search);
  const error = urlParams.get('error');
  useEffect(() => {
    const trekkerContext = {
      pageName: 'contactHostForm',
      section: ['contactHostForm'],
      experience,
      host,
      enabledForm,
      source,
    };
    if (
      (source === CONTACT_HOST_SOURCES.EXPERIENCE_PAGE ||
        source === CONTACT_HOST_SOURCES.LOCAL_PICKER) &&
      host &&
      experience
    ) {
      trekker.event('view', trekkerContext);
    }
    if (source === CONTACT_HOST_SOURCES.HOST_PAGE && enabledForm && host) {
      trekker.event('view', trekkerContext);
    }
  }, [experience, source, host, enabledForm, trekker]);
  return (
    <Section as="main" isNarrow noSpace="top" data-test-id="ContactHostForm">
      {(source === CONTACT_HOST_SOURCES.EXPERIENCE_PAGE ||
        source === CONTACT_HOST_SOURCES.LOCAL_PICKER) &&
        experience && (
          <FormExperienceHeader
            onBack={isCordova() && history.goBack}
            experienceImage={experience?.mainPhoto}
            localName={host?.firstName}
            localImage={host?.photo}
            title={experience?.title}
            rating={Number(experience?.aggregates?.average_rating)}
            nrOfReviews={Number(experience?.aggregates?.reviews_count)}
            nrOfOtherLocals={experience?.hosts?.length - 1}
            isLocalPicker={source === CONTACT_HOST_SOURCES.LOCAL_PICKER}
          />
        )}
      {source === CONTACT_HOST_SOURCES.HOST_PAGE && (
        <FormHeader
          onBack={isCordova() && history.goBack}
          hostImage={host?.photo}
          hostName={host?.firstName}
          hostCountry={host?.address?.country}
          enabledForm={enabledForm}
        />
      )}
      <section>
        <RequestPersonalizedOfferForm
          source={source}
          hostId={host?.id}
          experienceId={experience?.id}
        />
      </section>
      <aside className={CSS.BottomPart}>
        {error && <ErrorLabel>{error}</ErrorLabel>}
        <SafetyMessage />
      </aside>
    </Section>
  );
}

export default ContactHostForm;
